import { render, staticRenderFns } from "./RPSubTab.vue?vue&type=template&id=cb05e6b4&"
import script from "./RPSubTab.vue?vue&type=script&lang=js&"
export * from "./RPSubTab.vue?vue&type=script&lang=js&"
import style0 from "./RPSubTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports